<template>
  <div id="lecturer">
    <!-- 面包导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>讲师管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 讲师列表卡片区 -->
    <el-card class="box-card">
      <el-form :inline="true" ref="form" :model="queryMap" label-width="70px">
        <el-form-item label="讲师姓名">
          <el-input
            @keyup.enter.native="searchLecturer"
            @clear="searchLecturer"
            clearable
            v-model="queryMap.lecturerName"
            placeholder="请输入讲师姓名查询"
          ></el-input>
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            clearable
            @change="searchLecturer"
            @clear="searchLecturer"
            v-model="queryMap.statusId"
            placeholder="请选择状态"
          >
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="margin-left: 50px">
          <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button
            type="primary"
            @click="searchLecturer"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addDialogVisible = true"
            v-hasPermission="'lecturer:add'"
            >添加</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        v-loading="loading"
        :data="lecturerList"
        border
        style="width: 100%"
        height="660"
      >
        <el-table-column label="#" prop="id" width="50"></el-table-column>
        <el-table-column
          prop="lecturerName"
          label="讲师姓名"
          width="120"
        ></el-table-column>
        <el-table-column label="头像预览" width="100">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.headImgUrl"
              :preview-src-list="[scope.row.headImgUrl]"
              style="
                width: 60px;
                height: 60px;
                border-radius: 50%;
                object-fit: cover;
              "
              placeholder="暂无头像"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="position"
          label="职位"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="lecturerMobile"
          label="手机号"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="lecturerEmail"
          label="邮箱"
          width="200"
        ></el-table-column>
        <el-table-column prop="lecturerProportion" label="分成比例" width="120">
          <template slot-scope="scope">
            {{ (scope.row.lecturerProportion * 100).toFixed(2) }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序权重"
          width="100"
        ></el-table-column>
        <el-table-column prop="statusId" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.statusId"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-hasPermission="'lecturer:edit'"
              size="mini"
              type="primary"
              icon="el-icon-edit-outline"
              @click="edit(scope.row.id)"
            ></el-button>
            <el-button
              v-hasPermission="'lecturer:delete'"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="del(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 10px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryMap.pageNum"
        :page-sizes="[6, 10, 20, 30]"
        :page-size="queryMap.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 添加对话框 -->
      <el-dialog
        title="添加讲师"
        @close="closeDialog"
        :visible.sync="addDialogVisible"
        width="60%;"
      >
        <el-form
          :model="addForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="addFormRef"
          label-width="120px"
        >
          <el-form-item label="讲师姓名" prop="lecturerName">
            <el-input
              v-model="addForm.lecturerName"
              placeholder="请输入讲师姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师手机号" prop="lecturerMobile">
            <el-input
              v-model="addForm.lecturerMobile"
              placeholder="请输入讲师手机号"
              maxlength="11"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师邮箱" prop="lecturerEmail">
            <el-input
              v-model="addForm.lecturerEmail"
              placeholder="请输入讲师邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师职位" prop="position">
            <el-input
              v-model="addForm.position"
              placeholder="如：高级讲师、技术专家"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师头像" prop="headImgUrl">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleAvatarUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">上传头像</el-button>
            </el-upload>

            <el-image
              v-if="addForm.headImgUrl"
              :src="addForm.headImgUrl"
              style="
                width: 100px;
                height: 100px;
                border-radius: 50%;
                margin-top: 10px;
                object-fit: cover;
              "
            ></el-image>
          </el-form-item>

          <el-form-item label="讲师简介" prop="introduce">
            <el-input
              v-model="addForm.introduce"
              type="textarea"
              rows="4"
              placeholder="请输入讲师简介（最多2048字）"
              maxlength="2048"
            ></el-input>
          </el-form-item>

          <el-form-item label="分成比例(%)" prop="lecturerProportion">
            <el-input
              v-model.number="addForm.lecturerProportion"
              placeholder="请输入分成比例，如70表示70%"
              type="number"
              min="0"
              max="100"
              step="0.01"
            ></el-input>
            <div style="font-size: 12px; color: #888; margin-top: 5px">
              提示：输入0-100之间的数值，代表百分比
            </div>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="addForm.sort"
              placeholder="越小越靠前，默认1"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="statusId">
            <el-switch
              v-model="addForm.statusId"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="addLecturer"
            :loading="btnLoading"
            :disabled="btnDisabled"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <!-- 编辑对话框 -->
      <el-dialog
        title="编辑讲师"
        :visible.sync="editDialogVisible"
        width="60%"
        @close="editClose"
      >
        <el-form
          :model="editForm"
          :label-position="labelPosition"
          :rules="formRules"
          ref="editFormRef"
          label-width="120px"
        >
          <el-input type="hidden" v-model="editForm.id"></el-input>

          <el-form-item label="讲师姓名" prop="lecturerName">
            <el-input
              v-model="editForm.lecturerName"
              placeholder="请输入讲师姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师手机号" prop="lecturerMobile">
            <el-input
              v-model="editForm.lecturerMobile"
              placeholder="请输入讲师手机号"
              maxlength="11"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师邮箱" prop="lecturerEmail">
            <el-input
              v-model="editForm.lecturerEmail"
              placeholder="请输入讲师邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item label="讲师职位" prop="position">
            <el-input
              v-model="editForm.position"
              placeholder="如：高级讲师、技术专家"
            ></el-input>
          </el-form-item>

          <el-form-item label="当前头像">
            <el-image
              :src="editForm.headImgUrl"
              style="
                width: 100px;
                height: 100px;
                border-radius: 50%;
                object-fit: cover;
              "
              placeholder="暂无头像"
            ></el-image>
          </el-form-item>

          <el-form-item label="更换头像">
            <el-upload
              class="upload-demo"
              action="/api/upload"
              :on-success="handleEditAvatarUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
              accept="image/*"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
            >
              <el-button size="small" type="primary">上传新头像</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="讲师简介" prop="introduce">
            <el-input
              v-model="editForm.introduce"
              type="textarea"
              rows="4"
              placeholder="请输入讲师简介（最多2048字）"
              maxlength="2048"
            ></el-input>
          </el-form-item>

          <el-form-item label="分成比例(%)" prop="lecturerProportion">
            <el-input
              v-model.number="editForm.lecturerProportion"
              placeholder="请输入分成比例，如70表示70%"
              type="number"
              min="0"
              max="100"
              step="0.01"
            ></el-input>
          </el-form-item>

          <el-form-item label="排序权重" prop="sort">
            <el-input
              v-model.number="editForm.sort"
              placeholder="越小越靠前"
              type="number"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="statusId">
            <el-switch
              v-model="editForm.statusId"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="updateLecturer"
            :loading="btnLoading"
            :disabled="btnDisabled"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 基础状态
      loading: true,
      btnLoading: false,
      btnDisabled: false,
      labelPosition: "right",
      total: 0,

      // 对话框控制
      addDialogVisible: false,
      editDialogVisible: false,

      // 查询参数
      queryMap: {
        pageNum: 1,
        pageSize: 6,
        lecturerName: "",
        statusId: "",
      },

      // 数据列表
      lecturerList: [],

      // 表单数据
      addForm: {
        lecturerName: "",
        lecturerMobile: "",
        lecturerEmail: "",
        position: "",
        headImgUrl: "",
        introduce: "",
        lecturerProportion: 0, // 存储百分比数值，如70代表70%
        sort: 1,
        statusId: 1,
      },
      editForm: {},

      // 表单验证规则
      formRules: {
        lecturerName: [
          { required: true, message: "请输入讲师姓名", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "姓名长度在1-50个字符之间",
            trigger: "blur",
          },
        ],
        lecturerMobile: [
          { required: true, message: "请输入讲师手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        lecturerEmail: [
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: "请输入正确的邮箱格式",
            trigger: "blur",
          },
        ],
        position: [
          {
            max: 50,
            message: "职位名称最多50个字符",
            trigger: "blur",
          },
        ],
        headImgUrl: [
          { required: true, message: "请上传讲师头像", trigger: "blur" },
        ],
        lecturerProportion: [
          { required: true, message: "请输入分成比例", trigger: "blur" },
          {
            type: "number",
            min: 0,
            max: 100,
            message: "分成比例必须在0-100之间",
            trigger: "blur",
          },
        ],
        sort: [
          { type: "number", message: "排序权重必须为数字", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 加载讲师列表
    async getLecturerList() {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get("lecturer/list", {
          params: this.queryMap,
        });
        if (res.code !== 200) return this.$message.error("获取讲师列表失败");
        // 后端返回的分成比例是小数（如0.7），前端展示时转百分比
        this.lecturerList = res.data.rows.map((item) => ({
          ...item,
          lecturerProportion: item.lecturerProportion || 0,
        }));
        this.total = res.data.total;
      } catch (error) {
        this.$message.error("获取数据失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 搜索讲师
    searchLecturer() {
      this.queryMap.pageNum = 1;
      this.getLecturerList();
    },

    // 重置查询条件
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 6,
        lecturerName: "",
        statusId: "",
      };
      this.getLecturerList();
    },

    // 分页相关
    handleSizeChange(newSize) {
      this.queryMap.pageSize = newSize;
      this.getLecturerList();
    },
    handleCurrentChange(current) {
      this.queryMap.pageNum = current;
      this.getLecturerList();
    },

    // 头像上传成功回调
    handleAvatarUploadSuccess(response) {
      if (response.code === 200) {
        this.addForm.headImgUrl = response.data.url;
        this.$message.success("头像上传成功");
      } else {
        this.$message.error("头像上传失败：" + response.msg);
      }
    },

    // 编辑页头像上传成功回调
    handleEditAvatarUploadSuccess(response) {
      if (response.code === 200) {
        this.editForm.headImgUrl = response.data.url;
        this.$message.success("头像更新成功");
      } else {
        this.$message.error("头像更新失败：" + response.msg);
      }
    },

    // 上传失败回调
    handleUploadError() {
      this.$message.error("头像上传失败，请检查网络");
    },

    // 添加讲师
    async addLecturer() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;

        // 转换分成比例：前端输入的百分比（如70）转为小数（0.7）传给后端
        const formData = {
          ...this.addForm,
          lecturerProportion: this.addForm.lecturerProportion / 100,
        };

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.post("lecturer/add", formData);
          if (res.code === 200) {
            this.$notify.success({ title: "成功", message: "讲师添加成功" });
            this.addDialogVisible = false;
            this.getLecturerList();
          } else {
            this.$message.error("添加失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("添加失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 编辑讲师
    async edit(id) {
      try {
        const { data: res } = await this.$http.get(`lecturer/${id}`);
        if (res.code !== 200) return this.$message.error("获取讲师详情失败");
        // 后端返回的是小数，前端展示为百分比数值
        this.editForm = {
          ...res.data,
          lecturerProportion: (res.data.lecturerProportion * 100).toFixed(2),
        };
        this.editDialogVisible = true;
      } catch (error) {
        this.$message.error("获取详情失败，请重试");
      }
    },

    // 更新讲师
    async updateLecturer() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;

        // 转换分成比例：前端输入的百分比转为小数
        const formData = {
          ...this.editForm,
          lecturerProportion: this.editForm.lecturerProportion / 100,
        };

        this.btnLoading = true;
        this.btnDisabled = true;
        try {
          const { data: res } = await this.$http.put(
            `lecturer/update/${this.editForm.id}`,
            formData
          );
          if (res.code === 200) {
            this.$notify.success({ title: "成功", message: "讲师更新成功" });
            this.editDialogVisible = false;
            this.getLecturerList();
          } else {
            this.$message.error("更新失败：" + res.msg);
          }
        } catch (error) {
          this.$message.error("更新失败，请重试");
        } finally {
          this.btnLoading = false;
          this.btnDisabled = false;
        }
      });
    },

    // 删除讲师
    async del(id) {
      try {
        const confirm = await this.$confirm(
          "此操作将永久删除该讲师信息，是否继续？",
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirm !== "confirm") return;

        const { data: res } = await this.$http.delete(`lecturer/delete/${id}`);
        if (res.code === 200) {
          this.$notify.success({ title: "成功", message: "讲师删除成功" });
          this.getLecturerList();
        } else {
          this.$message.error("删除失败：" + res.msg);
        }
      } catch (error) {
        if (error !== "cancel") {
          this.$message.error("删除失败，请重试");
        }
      }
    },

    // 切换状态
    async changeStatus(row) {
      const originalStatus = row.statusId;
      try {
        const { data: res } = await this.$http.put(
          `lecturer/updateStatus/${row.id}/${row.statusId}`
        );
        if (res.code !== 200) {
          row.statusId = originalStatus; // 回滚状态
          return this.$message.error("状态更新失败：" + res.msg);
        }
        this.$notify.success({
          title: "成功",
          message: `讲师已${row.statusId === 1 ? "启用" : "禁用"}`,
        });
      } catch (error) {
        row.statusId = originalStatus; // 回滚状态
        this.$message.error("状态更新失败，请重试");
      }
    },

    // 关闭添加对话框
    closeDialog() {
      this.$refs.addFormRef.clearValidate();
      this.addForm = {
        lecturerName: "",
        lecturerMobile: "",
        lecturerEmail: "",
        position: "",
        headImgUrl: "",
        introduce: "",
        lecturerProportion: 0,
        sort: 1,
        statusId: 1,
      };
    },

    // 关闭编辑对话框
    editClose() {
      this.$refs.editFormRef.clearValidate();
      this.editForm = {};
    },

    // 获取Token
    getToken() {
      return localStorage.getItem("token") || "";
    },
  },

  created() {
    this.getLecturerList();
  },
};
</script>

<style scoped>
.upload-demo {
  margin-bottom: 10px;
}
</style>
